<template>
    <div class="drive-items">
        <!-- 云盘列表 -->
        <div class="drive-item" v-for="drive in $store.state.drives" :key="drive.id" @click="openDrive(drive.id)"
            @contextmenu.prevent="dealShowRightMenu(drive, $event)"
            :class="$store.state.curDriveId == drive.id ? ($route.path=='/mc_project/lite_file' ? 'selected' : '') : ''">
            <div :class="'drive-item-icon drive-icon-' + drive.type"></div>
            <div class="drive-item-text">
                <span class="drive-item-name" :title="drive.name">{{ drive.name }}</span>
                <span class="drive-item-desc">{{ getDriveAccount(drive) }}</span>
            </div>
            <div class="drive-item-line"></div>
            <div class="drive_more_icon" @click.stop="dealShowRightMenu(drive, $event)"></div>
            <div class="drive_more_items" v-show="cueDriveMoreId==drive.id" :style="{ left: rightMenuX + 'px', top: rightMenuY + 'px' }">
                <div class="drive_more_item drive_rename" @click.stop="renameDrivePopup(drive)">{{$t('language.common.rename')}}</div>
                <div class="drive_more_item drive_edit" @click.stop="editDrivePopup(drive)">{{$t('language.leftBanner.edit')}}</div>
                <div class="drive_more_item drive_delete" @click.stop="deleteDrivePopup(drive)">{{ $t('language.leftBanner.remove') }}</div>
                <div class="drive_more_item drive_properties" @click.stop="infoDrive(drive)">{{$t('language.common.properties')}}</div>
            </div>
        </div>
        <!-- 云盘信息 -->
        <div class="lite_popup drive_info" v-show="driveInfo.show" @click.stop="blankClick()">
            <div class="lite_popup_box">
                <div class="lite_popup_title">
                    <span>{{$t('language.common.properties')}}</span>
                    <div class="icon white-close dialog-close" @click="driveInfo.show = false"></div>
                </div>
                <div class="lite_popup_content">
                    <el-form label-width="120px">
                        <!-- 所有云盘 -->
                        <el-form-item :label="$t('language.popup.addCloudPopup.cloudName')" v-if="thisDrive">
                            <div class="drive_info_text">{{ thisDrive.name }}</div>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.cloudType')" v-if="thisDrive">
                            <div class="drive_info_text">{{ thisDrive.type }}</div>
                        </el-form-item>
                         <el-form-item :label="$t('language.popup.addCloudPopup.addedTime')" v-if="thisDrive">
                            <div class="drive_info_text">{{ formatDate(thisDrive.ctime) }}</div>
                        </el-form-item>
                        <!-- 一般云盘 -->
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')" v-if="driveInfo.name">
                            <div class="drive_info_text">{{ driveInfo.name }}</div>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.email">
                            <div class="drive_info_text">{{ driveInfo.email }}</div>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.usedSpace')" v-if="driveInfo.used">
                            <div class="drive_info_text">{{ formatBytes(driveInfo.used) }}</div>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.totalSpace')" v-if="driveInfo.total">
                            <div class="drive_info_text">{{ formatBytes(driveInfo.total) }}</div>
                        </el-form-item>
                        <!-- FTP -->
                        <div v-if="driveInfo.ftp.host">
                            <el-form-item :label="$t('language.popup.addCloudPopup.protocol')">
                                <div class="drive_info_text">{{ driveInfo.ftp.protocol }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                                <div class="drive_info_text">{{ driveInfo.ftp.host }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                                <div class="drive_info_text">{{ driveInfo.ftp.port }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.ftp.username }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.passive')">
                                <div class="drive_info_text">{{ driveInfo.ftp.passive }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.encoding')">
                                <div class="drive_info_text">{{ driveInfo.ftp.encoding }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                                <div class="drive_info_text">{{ driveInfo.ftp.path }}</div>
                            </el-form-item>
                        </div>
                        <!-- SFTP -->
                        <div v-if="driveInfo.sftp.host">
                            <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                                <div class="drive_info_text">{{ driveInfo.sftp.host }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                                <div class="drive_info_text">{{ driveInfo.sftp.port }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.sftp.username }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                                <div class="drive_info_text">{{ driveInfo.sftp.path }}</div>
                            </el-form-item>
                        </div>
                        <!-- WebDAV -->
                        <div v-if="driveInfo.webdav.url">
                            <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                                <div class="drive_info_text">{{ driveInfo.webdav.url }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.webdav.username }}</div>
                            </el-form-item>
                        </div>
                        <!-- MediaFire -->
                        <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.mediafire.email">
                            <div class="drive_info_text">{{ driveInfo.mediafire.email }}</div>
                        </el-form-item>
                        <!-- SugarSync -->
                        <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.sugarsync.email">
                            <div class="drive_info_text">{{ driveInfo.sugarsync.email }}</div>
                        </el-form-item>
                        <!-- Backblaze -->
                        <el-form-item :label="$t('language.popup.addCloudPopup.keyID')" v-if="driveInfo.backblaze.applicationKeyId">
                            <div class="drive_info_text">{{ driveInfo.backblaze.applicationKeyId }}</div>
                        </el-form-item>
                        <!-- Amazon S3 -->
                        <div v-if="driveInfo.amazons3">
                          <el-form-item :label="$t('language.popup.addCloudPopup.accessKeyId')" v-if="driveInfo.amazons3.accessKeyId">
                              <div class="drive_info_text">{{ driveInfo.amazons3.accessKeyId }}</div>
                          </el-form-item>
                        </div>
                        <!-- Wasabi -->
                        <div v-if="driveInfo.wasabi">
                          <el-form-item :label="$t('language.popup.addCloudPopup.accessKeyId')" v-if="driveInfo.wasabi.accessKeyId">
                              <div class="drive_info_text">{{ driveInfo.wasabi.accessKeyId }}</div>
                          </el-form-item>
                        </div>
                        <!-- Egnyte -->
                        <div v-if="driveInfo.egnyte">
                            <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.egnyte.email">
                                <div class="drive_info_text">{{ driveInfo.egnyte.email }}</div>
                            </el-form-item>
                        </div>
                        <!-- MySQL -->
                        <div v-if="driveInfo.mysql.host">
                            <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                                <div class="drive_info_text">{{ driveInfo.mysql.host }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                                <div class="drive_info_text">{{ driveInfo.mysql.port }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.mysql.username }}</div>
                            </el-form-item>
                        </div>
                        <!-- Website -->
                        <div class="websit_info_items myscroll">
                            <div v-if="driveInfo.website.sites">
                                <el-form-item :label="$t('language.popup.addCloudPopup.server') + ' ' + (index + 1)" v-for="(site, index) in driveInfo.website.sites" :key="index">
                                    <div class="drive_info_text">{{ site.username+'@'+site.host+":"+site.port }}</div>
                                </el-form-item>
                            </div>
                            <div v-if="driveInfo.website.dbs">
                                <el-form-item :label="'DB ' + (index + 1)" v-for="(site, index) in driveInfo.website.dbs" :key="index">
                                    <div class="drive_info_text">{{ site.username+'@'+site.host+":"+site.port }}</div>
                                </el-form-item>
                            </div>
                        </div>
                        <!-- GooglePhotos -->
                        <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.googlephotos.email">
                            <div class="drive_info_text">{{ driveInfo.googlephotos.email }}</div>
                        </el-form-item>
                        <!-- HiDrive -->
                        <div v-if="driveInfo.hidrive.username">
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.hidrive.username }}</div>
                            </el-form-item>
                        </div>
                        <!-- Yandex -->
                        <div v-if="driveInfo.yandex.username">
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.yandex.username }}</div>
                            </el-form-item>
                        </div>
                        <!-- NAS -->
                        <div v-if="driveInfo.nas.type">
                            <el-form-item label="Via">
                                <div class="drive_info_text">{{ driveInfo.nas.type }}</div>
                            </el-form-item>
                            <div v-if="driveInfo.nas.type == 'ftp'">
                                <el-form-item :label="$t('language.popup.addCloudPopup.protocol')">
                                    <div class="drive_info_text">{{ driveInfo.nas.ftp.protocol }}</div>
                                </el-form-item>
                                <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                                    <div class="drive_info_text">{{ driveInfo.nas.ftp.host }}</div>
                                </el-form-item>
                                <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                                    <div class="drive_info_text">{{ driveInfo.nas.ftp.port }}</div>
                                </el-form-item>
                                <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                    <div class="drive_info_text">{{ driveInfo.nas.ftp.username }}</div>
                                </el-form-item>
                                <el-form-item :label="$t('language.popup.addCloudPopup.passive')">
                                    <div class="drive_info_text">{{ driveInfo.nas.ftp.passive }}</div>
                                </el-form-item>
                                <el-form-item :label="$t('language.popup.addCloudPopup.encoding')">
                                    <div class="drive_info_text">{{ driveInfo.nas.ftp.encoding }}</div>
                                </el-form-item>
                                <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                                    <div class="drive_info_text">{{ driveInfo.nas.ftp.path }}</div>
                                </el-form-item>
                            </div>
                            <div v-if="driveInfo.nas.type == 'webdav'">
                                <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                                    <div class="drive_info_text">{{ driveInfo.nas.webdav.url }}</div>
                                </el-form-item>
                                <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                    <div class="drive_info_text">{{ driveInfo.nas.webdav.username }}</div>
                                </el-form-item>
                            </div>
                        </div>
                        <!-- IceDrive -->
                        <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.icedrive.email">
                            <div class="drive_info_text">{{ driveInfo.icedrive.email }}</div>
                        </el-form-item>
                        <!-- OwnCloud -->
                        <div v-if="driveInfo.owncloud.url">
                            <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                                <div class="drive_info_text">{{ driveInfo.owncloud.url }}</div>
                            </el-form-item>
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.owncloud.username }}</div>
                            </el-form-item>
                        </div>
                        <!-- IDriveE2 -->
                        <div v-if="driveInfo.idrivee2">
                          <el-form-item :label="$t('language.popup.addCloudPopup.accessKeyId')" v-if="driveInfo.idrivee2.accessKeyId">
                              <div class="drive_info_text">{{ driveInfo.idrivee2.accessKeyId }}</div>
                          </el-form-item>
                        </div>
                        <!-- ADrive -->
                        <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.adrive.email">
                            <div class="drive_info_text">{{ driveInfo.adrive.email }}</div>
                        </el-form-item>
                        <!-- WEB.DE -->
                        <el-form-item :label="$t('language.popup.email')" v-if="driveInfo.webde.email">
                            <div class="drive_info_text">{{ driveInfo.webde.email }}</div>
                        </el-form-item>
                        <!-- CloudMe -->
                        <div v-if="driveInfo.cloudme.username">
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.cloudme.username }}</div>
                            </el-form-item>
                        </div>
                        <!-- MyDrive -->
                        <div v-if="driveInfo.mydrive.username">
                            <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                <div class="drive_info_text">{{ driveInfo.mydrive.username }}</div>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
        <!-- 重命名 -->
        <liteInput @click.native.stop="blankClick()" ref="inputPopup" :autoClose="false" :data="input_popup_data" :maxlength="255" @ok="inputPopupOK" />
        <!-- 确认弹窗 -->
        <liteConfirm @click.native.stop="blankClick()" ref="confirmPopup" :data="confirm_popup_data" @ok="confirmPopupOK" />
        <!-- 编辑云盘 -->
        <liteAddDrive @click.native.stop="blankClick()" :auth="auth" @submit="editCloud()" />
    </div>
</template>

<script>
import { Message } from "element-ui";
import requestUtils from '@/js/request_util.js';
import liteInput from '@/components/workspace/lite_input.vue';
import liteConfirm from '@/components/workspace/lite_confirm.vue';
import liteAddDrive from "@/components/workspace/lite_add_drive";

export default {
    components: {
        liteInput,
        liteConfirm,
        liteAddDrive,
    },
    data() {
        return {
            cueDriveMoreId: '',
            rightMenuX: 0,
            rightMenuY: 0,
            // 编辑云盘
            auth: {
                show: false,
                loading: false,
                did: "",
                aid: "",
                customApps: [],
                systemAppAvailable: false,
                type: "",
                name: "",
                ftp: {
                    protocol: "ftp-plain",
                    host: "",
                    port: 21,
                    username: "",
                    password: "",
                    passive: true,
                    encoding: "UTF-8",
                    path: "",
                },
                sftp: {
                    host: "",
                    port: 22,
                    username: "",
                    password: "",
                    privateKey: "",
                    passphrase: "",
                    path: "",
                },
                webdav: {
                    url: "",
                    username: "",
                    password: "",
                },
                mediafire: {
                    email: "",
                    password: "",
                },
                sugarsync: {
                    email: "",
                    password: "",
                },
                mega: {
                    email: "",
                    password: "",
                },
                mysql: {
                    host: "",
                    port: 3306,
                    username: "",
                    password: "",
                },
                backblaze: {
                    applicationKeyId: "",
                    applicationKey: "",
                },
                website: {
                    sites: [],
                    dbs: [],
                },
                icloud: {
                    domain: "com",
                    appleId: "",
                    password: "",
                    sessionId: "",
                    code: "",
                    secs: 0,
                    timer: null,
                },
                amazons3: {
                    accessKeyId: "",
                    secretAccessKey: "",
                    bucket: "",
                    region: "",
                    endpoint: "",
                },
                wasabi: {
                    accessKeyId: "",
                    secretAccessKey: "",
                },
                egnyte: {
                    domain: "",
                    accessKeyId: "",
                    secretAccessKey: "",
                    email: "",
                    password: "",
                },
                hidrive: {
                    username: "",
                    password: "",
                },
                yandex: {
                    username: "",
                    password: "",
                },
                nas: {
                    type: "ftp",
                    ftp: {
                        protocol: "ftp-plain",
                        host: "",
                        port: 21,
                        username: "",
                        password: "",
                        passive: true,
                        encoding: "UTF-8",
                        path: "",
                    },
                    webdav: {
                        url: "",
                        username: "",
                        password: "",
                    },
                },
                icedrive: {
                    email: "",
                    password: "",
                },
                owncloud: {
                    url: "",
                    username: "",
                    password: "",
                },
                idrivee2: {
                    accessKeyId: "",
                    secretAccessKey: "",
                    endpoint: "",
                },
                adrive: {
                    email: "",
                    password: "",
                },
                webde: {
                    email: "",
                    password: "",
                },
                cloudme: {
                    username: "",
                    password: "",
                },
                mydrive: {
                    username: "",
                    password: "",
                },
            },
            // 云盘信息
            thisDrive: null,
            driveInfo: {
                show: false,
                used: null,
                total: null,
                email: null,
                name: null,
                ftp: {
                    protocol: null,
                    host: null,
                    port: null,
                    username: null,
                    passive: null,
                    encoding: null,
                    path: null,
                },
                sftp: {
                    host: null,
                    port: null,
                    username: null,
                    path: null,
                },
                webdav: {
                    url: null,
                    username: null,
                },
                mediafire: {
                    email: null,
                },
                sugarsync: {
                    email: null,
                },
                mega: {
                    email: null,
                },
                mysql: {
                    host: null,
                    port: null,
                    username: null,
                },
                backblaze: {
                    applicationKeyId: null,
                },
                website: {
                    sites: [],
                    dbs: [],
                },
                googlephotos: {
                    email: null,
                },
                icloud: {
                    domain: null,
                    appleId: null,
                },
                amazons3: {
                    accessKeyId: null,
                    secretAccessKey: null,
                    bucket: null,
                    region: null,
                    endpoint: null,
                },
                wasabi: {
                    accessKeyId: null,
                    secretAccessKey: null,
                },
                egnyte: {
                    domain: null,
                    accessKeyId: null,
                    secretAccessKey: null,
                    email: null,
                    password: null,
                },
                hidrive: {
                    username: null,
                },
                yandex: {
                    username: null,
                },
                nas: {
                    type: null,
                    ftp: null,
                    webdav: null,
                },
                icedrive: {
                    email: null,
                },
                owncloud: {
                    url: null,
                    username: null,
                },
                idrivee2: {
                    accessKeyId: null,
                    secretAccessKey: null,
                    endpoint: null,
                },
                adrive: {
                    email: null,
                },
                webde: {
                    email: null,
                },
                cloudme: {
                    username: null,
                },
                mydrive: {
                    username: null,
                },
            },
            // 输入框弹窗
            input_popup_data: {
                id: '',
                type: '',
                title: '',
                value: '',
                placeholder: '',
            },
            // 确认弹窗
            confirm_popup_data: {
                id: '',
                type: '',
                title: '',
                desc: '',
            },
        }
    },
    mounted() {
        // 云盘授权结果
        const url = window.location.href;
        const params = new URL(url).searchParams;
        const resultBase64 = params.get("result");
        if (resultBase64) {
            this.$cookies.set("authResult", resultBase64, "30s");
        }
        // 初始化，加载云盘信息
        this.loadDrives(() => {
            this.checkAddCloudResult();
        });
        // 隐藏云盘右键菜单
        document.addEventListener('click', () => {
            this.cueDriveMoreId = ''
        })
    },
    methods: {
        // 检查云盘添加结果
        checkAddCloudResult() {
            const resultBase64 = this.$cookies.get("authResult");
            if (resultBase64) {
                this.$cookies.remove("authResult");
                try {
                    var result = new TextDecoder().decode(Uint8Array.from(atob(resultBase64), c => c.charCodeAt(0)));
                    var json = JSON.parse(result);
                    if (json.status == "success") {
                        // 添加成功
                        var deiveId = json.data;
                        // 并且打开
                        this.$router.push('/mc_project/lite_file');
                        this.openDrive(deiveId);
                    } else {
                        // 添加失败原因
                        Message.error(json.data);
                    }
                } catch (e) {
                    // 解析失败
                    Message.error(resultBase64)
                }
            }
        },
        // 获取云盘账户信息
        getDriveAccount(drive) {
            if (drive.loadDriveInfo) {
                return this.$t('language.common.load');
            } else if (drive.driveInfo == "error") {
                return this.$t('language.common.failure');
            } else if (drive.driveInfo) {
                if (drive.driveInfo.email) {
                    return drive.driveInfo.email;
                } else if (drive.driveInfo.name) {
                    return drive.driveInfo.name;
                } else if (drive.driveInfo.ftp) {
                    const ftp = drive.driveInfo.ftp;
                    return ftp.username+"@"+ftp.host+":"+ftp.port;
                } else if (drive.driveInfo.sftp) {
                    const sftp = drive.driveInfo.sftp;
                    return sftp.username+"@"+sftp.host+":"+sftp.port;
                } else if (drive.driveInfo.webdav) {
                    const webdav = drive.driveInfo.webdav;
                    return webdav.username;
                } else if (drive.driveInfo.mysql) {
                    const mysql = drive.driveInfo.mysql;
                    return mysql.username+"@"+mysql.host+":"+mysql.port;
                } else if (drive.driveInfo.backblaze) {
                    const backblaze = drive.driveInfo.backblaze;
                    return backblaze.applicationKeyId;
                } else if (drive.driveInfo.website) {
                    const website = drive.driveInfo.website;
                    return 'Site:' + website.sites.length + ' DB:' + website.dbs.length;
                } else if (drive.driveInfo.googlephotos) {
                    return drive.driveInfo.googlephotos.email;
                } else if (drive.driveInfo.amazons3) {
                    if (drive.driveInfo.amazons3.bucket) {
                        return drive.driveInfo.amazons3.bucket;
                    } else {
                        return drive.driveInfo.amazons3.accessKeyId;
                    }
                } else if (drive.driveInfo.wasabi) {
                    return drive.driveInfo.wasabi.accessKeyId;
                } else if (drive.driveInfo.egnyte) {
                    return drive.driveInfo.egnyte.email;
                } else if (drive.driveInfo.hidrive) {
                    return drive.driveInfo.hidrive.username;
                } else if (drive.driveInfo.yandex) {
                    return drive.driveInfo.yandex.username;
                } else if (drive.driveInfo.nas) {
                    if (drive.driveInfo.nas.type == 'ftp') {
                        const ftp = drive.driveInfo.nas.ftp;
                        return ftp.username+"@"+ftp.host+":"+ftp.port;
                    } else {
                        const webdav = drive.driveInfo.nas.webdav;
                        return webdav.username;
                    }
                } else if (drive.driveInfo.icedrive) {
                    return drive.driveInfo.icedrive.email;
                } else if (drive.driveInfo.owncloud) {
                    return drive.driveInfo.owncloud.username;
                } else if (drive.driveInfo.idrivee2) {
                    return drive.driveInfo.idrivee2.accessKeyId;
                } else if (drive.driveInfo.adrive) {
                    return drive.driveInfo.adrive.email;
                } else if (drive.driveInfo.webde) {
                    return drive.driveInfo.webde.email;
                } else if (drive.driveInfo.cloudme) {
                    return drive.driveInfo.cloudme.username;
                } else if (drive.driveInfo.mydrive) {
                    return drive.driveInfo.mydrive.username;
                }
                return "";
            } else {
                return this.$t('language.common.waiting');
            }
        },
        dealShowRightMenu(drive, event) {
            this.$nextTick(() => {
                this.rightMenuX = event.clientX;
                this.rightMenuY = event.clientY;
                if (this.rightMenuY + 140 > window.innerHeight) {
                    this.rightMenuY -= 140;
                }
                if (this.rightMenuX + 138 > 550) {
                    this.rightMenuX -= 138;
                }
                this.cueDriveMoreId = drive.id;
            });
        },
        // 阻止跳转到文件管理
        blankClick() {
        },
        // 确认弹窗
        async confirmPopupOK() {
            const id = this.confirm_popup_data.id;
            const type = this.confirm_popup_data.type;
            if (type == 'delete') {
                this.deleteDrive(id);
            }
        },
        // 输入框弹窗确认
        inputPopupOK() {
            const id = this.input_popup_data.id;
            const type = this.input_popup_data.type;
            const name = this.input_popup_data.value;
            if (type === "rename") {
                this.renameDrive(id, name);
            }
        },
        // 格式化字节数
        formatBytes(value) {
            if (value === null || value === undefined) return '-';
            if (value === 0) return '0B';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
            const i = Math.floor(Math.log(value) / Math.log(k));
            return (value / Math.pow(k, i)).toFixed(2) + sizes[i];
        },
        // 格式化时间
        formatDate(value) {
            if (!value) return '';
            const date = new Date(value);
            return date.toLocaleString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).replace(/,/g, '');
        },
        // 展开云盘根目录
        openDrive(id) {
            this.$store.state.curDriveId = id;
            this.$store.state.curNode = null;
            this.$store.state.curStart = null;
            // 普通云盘切换只展开根目录，允许 lite_file 命中该根目录缓存。
            this.$store.state.needLoad = { useCache: true };
        },
        // 云盘信息
        infoDrive(drive) {
            this.cueDriveMoreId = '';
            this.sendRequest("/drive/info", { id: drive.id }, (data) => {
                this.thisDrive = drive;
                this.driveInfo.used = 0;
                this.driveInfo.total = 0;
                this.driveInfo.email = null;
                this.driveInfo.name = null;
                this.driveInfo.ftp = {};
                this.driveInfo.sftp = {};
                this.driveInfo.webdav = {};
                this.driveInfo.mediafire = {};
                this.driveInfo.sugarsync = {};
                this.driveInfo.mega = {};
                this.driveInfo.mysql = {};
                this.driveInfo.backblaze = {};
                this.driveInfo.website = {sites: [], db: []};
                this.driveInfo.googlephotos = {};
                this.driveInfo.icloud = {};
                this.driveInfo.amazons3 = {};
                this.driveInfo.hidrive = {};
                this.driveInfo.yandex = {};
                this.driveInfo.nas = {};
                this.driveInfo.icedrive = {};
                this.driveInfo.owncloud = {};
                this.driveInfo.idrivee2 = {};
                this.driveInfo.adrive = {};
                this.driveInfo.webde = {};
                this.driveInfo.cloudme = {};
                this.driveInfo.mydrive = {};
                Object.assign(this.driveInfo, data);
                this.driveInfo.show = true;
            }, () => {
                this.thisDrive = drive;
                this.driveInfo.used = 0;
                this.driveInfo.total = 0;
                this.driveInfo.email = null;
                this.driveInfo.name = null;
                this.driveInfo.ftp = {};
                this.driveInfo.sftp = {};
                this.driveInfo.webdav = {};
                this.driveInfo.mediafire = {};
                this.driveInfo.sugarsync = {};
                this.driveInfo.mega = {};
                this.driveInfo.mysql = {};
                this.driveInfo.backblaze = {};
                this.driveInfo.website = {sites: [], db: []};
                this.driveInfo.googlephotos = {};
                this.driveInfo.icloud = {};
                this.driveInfo.amazons3 = {};
                this.driveInfo.hidrive = {};
                this.driveInfo.yandex = {};
                this.driveInfo.nas = {};
                this.driveInfo.icedrive = {};
                this.driveInfo.owncloud = {};
                this.driveInfo.idrivee2 = {};
                this.driveInfo.adrive = {};
                this.driveInfo.webde = {};
                this.driveInfo.cloudme = {};
                this.driveInfo.mydrive = {};
                this.driveInfo.show = true;
            });
        },
        // 云盘基本参数
        infoDriveBase(drive, callback) {
            this.sendRequest("/drive/info", { id: drive.id, base: true }, (data) => {
                if (callback) {
                    callback(data);
                }
            });
        },
        // 重命名云盘弹窗
        renameDrivePopup(drive) {
            this.cueDriveMoreId = '';
            this.input_popup_data.id = drive.id;
            this.input_popup_data.type = "rename";
            this.input_popup_data.title = this.$t('language.common.rename');
            this.input_popup_data.value = drive.name;
            this.input_popup_data.placeholder = "";
            this.$refs.inputPopup.loading = false;
            this.$refs.inputPopup.show = true;
        },
        // 重命名云盘
        renameDrive(id, name) {
            this.$refs.inputPopup.loading = true;
            this.sendRequest("/drive/rename", { id: id, name: name }, () => {
                this.getDrive(id).name = name;
                this.$refs.inputPopup.loading = false;
                this.$refs.inputPopup.show = false;
            }, () => {
                this.$refs.inputPopup.loading = false;
            });
        },
        // 删除云盘弹窗
        deleteDrivePopup(drive) {
            this.cueDriveMoreId = '';
            this.confirm_popup_data.id = drive.id;
            this.confirm_popup_data.type = "delete";
            this.confirm_popup_data.title = this.$t('language.common.delete');
            this.confirm_popup_data.desc = this.$t('language.popup.addCloudPopup.removeContent');
            this.$refs.confirmPopup.show = true;
        },
        // 删除云盘
        deleteDrive(id) {
            this.sendRequest("/drive/delete", { id: id }, () => {
                this.$store.state.curDriveId = '';
                if (this.$store.state.drives.length == 1) {
                    this.$emit("noneDrive");
                }
                this.loadDrives(() => {
                    this.listTasks();
                    this.$store.state.needLoadDriveInfo = true;
                });
            })
        },
        // 获取云盘
        getDrive(id) {
            for (let i = 0; i < this.$store.state.drives.length; i++) {
                let drive = this.$store.state.drives[i];
                if (drive.id === id) {
                    return drive;
                }
            }
            return null;
        },
        // 获取任务列表
        listTasks(callback) {
            this.sendRequest("/task/list", {}, (data) => {
                this.$store.state.tasks = data;
                if (callback) callback();
            })
        },
        // 加载云盘
        loadDrives(callback) {
            this.sendRequest("/drive/list", {}, (data) => {
                this.$store.state.drives = data;
                if (callback) {
                    callback();
                }
            })
        },
        // 编辑云盘弹窗
        editDrivePopup(drive) {
            this.cueDriveMoreId = '';
            this.auth.did = drive.id;
            this.auth.aid = drive.aid || "";
            this.auth.customApps = [];
            this.auth.systemAppAvailable = false;
            this.auth.type = drive.type;
            this.auth.name = drive.name;
            if (['FTP','SFTP','WebDAV','MediaFire','SugarSync','MySQL','Backblaze','Website','ICloudPhotos','AmazonS3','MEGA','Wasabi','Egnyte'].includes(drive.type)) {
                this.infoDriveBase(drive, (data) => {
                    if (data.icloud) {
                        this.auth.icloud.domain = data.icloud.domain;
                        this.auth.icloud.appleId = data.icloud.appleId;
                        this.auth.icloud.password = "";
                        this.auth.icloud.sessionId = "";
                        this.auth.icloud.code = "";
                        this.auth.icloud.secs = 0;
                        this.auth.icloud.timer = null;
                    }
                    if (data.ftp) {
                        this.auth.ftp.protocol = data.ftp.protocol;
                        this.auth.ftp.host = data.ftp.host;
                        this.auth.ftp.port = data.ftp.port;
                        this.auth.ftp.username = data.ftp.username;
                        this.auth.ftp.password = "";
                        this.auth.ftp.passive = data.ftp.passive;
                        this.auth.ftp.encoding = data.ftp.encoding;
                        this.auth.ftp.path = data.ftp.path;
                    }
                    if (data.sftp) {
                        this.auth.sftp.host = data.sftp.host;
                        this.auth.sftp.port = data.sftp.port;
                        this.auth.sftp.username = data.sftp.username;
                        this.auth.sftp.password = "";
                        this.auth.sftp.privateKey = "";
                        this.auth.sftp.passphrase = "";
                        this.auth.sftp.path = data.sftp.path;
                    }
                    if (data.webdav) {
                        this.auth.webdav.url = data.webdav.url;
                        this.auth.webdav.username = data.webdav.username;
                        this.auth.webdav.password = "";
                    }
                    if (data.mediafire) {
                        this.auth.mediafire.email = data.mediafire.email;
                        this.auth.mediafire.password = "";
                    }
                    if (data.sugarsync) {
                        this.auth.sugarsync.email = data.sugarsync.email;
                        this.auth.sugarsync.password = "";
                    }
                    if (data.mega) {
                        this.auth.mega.email = data.mega.email;
                        this.auth.mega.password = "";
                    }
                    if (data.mysql) {
                        this.auth.mysql.host = data.mysql.host;
                        this.auth.mysql.port = data.mysql.port;
                        this.auth.mysql.username = data.mysql.username;
                        this.auth.mysql.password = "";
                    }
                    if (data.backblaze) {
                        this.auth.backblaze.applicationKeyId = data.backblaze.applicationKeyId;
                        this.auth.backblaze.applicationKey = "";
                    }
                    if (data.amazons3) {
                        this.auth.amazons3.accessKeyId = data.amazons3.accessKeyId;
                        this.auth.amazons3.secretAccessKey = data.amazons3.secretAccessKey;
                        this.auth.amazons3.bucket = data.amazons3.bucket;
                        this.auth.amazons3.region = data.amazons3.region;
                        this.auth.amazons3.endpoint = data.amazons3.endpoint;
                    }
                    if (data.wasabi) {
                        this.auth.wasabi.accessKeyId = data.wasabi.accessKeyId;
                        this.auth.wasabi.secretAccessKey = data.wasabi.secretAccessKey;
                    }
                    if (data.egnyte) {
                        this.auth.egnyte.domain = data.egnyte.domain;
                        this.auth.egnyte.accessKeyId = data.egnyte.accessKeyId;
                        this.auth.egnyte.secretAccessKey = data.egnyte.secretAccessKey;
                        this.auth.egnyte.email = data.egnyte.email;
                        this.auth.egnyte.password = data.egnyte.password;
                    }
                    if (data.website) {
                        let sites = data.website.sites;
                        for (let i = 0; i < sites.length; i++) {
                            sites[i].show = false;
                        }
                        let dbs = data.website.dbs;
                        for (let i = 0; i < dbs.length; i++) {
                            dbs[i].show = false;
                        }
                        this.auth.website.sites = sites;
                        this.auth.website.dbs = dbs;
                    }
                });
            }
            this.auth.loading = false;
            this.auth.show = true;
        },
        // 编辑云盘
        editCloud() {
            if (this.auth.loading) return;
            this.auth.loading = true;
            this.sendRequest("/drive/auth", this.auth, (data) => {
                this.auth.loading = false;
                this.auth.show = false;
                if (data.type == "url") {
                    // 需要跳转授权
                    location.href = data.data;
                } else {
                    // 已经成功，重新加载
                    this.loadDrives(() => {
                        // 并且打开
                        this.openDrive(data.data.id);
                        this.$store.state.needLoadDriveInfo = true;
                    });
                }
            }, () => {
                this.auth.loading = false;
            });
        },
        // 发送Lite请求
        sendRequest(path, data, callback, errCallback, options) {
            requestUtils.doLiteRequest(path, data, options)
                .then(res => {
                    let code = res.code
                    let msg = res.msg
                    if (msg == undefined) {
                        msg = res.message;
                    }
                    if (code == 200) {
                        // 请求成功
                        if (callback) {
                            callback(res.data);
                        }
                    } else if (code == 400) {
                        // 请求失败
                        Message.warning(msg);
                        if (errCallback) {
                            errCallback()
                        }
                    } else {
                        if (msg == "Unauthorized") {
                            // 未登录
                            location.href = location.host.includes("localhost") ? "http://localhost:8080/share/123" : "https://" + location.host + "/sign"
                        } else {
                            // 服务器异常
                            if (!msg.includes("LiteService")) {
                                this.$message({
                                    message: msg,
                                    type: 'error',
                                    duration: 5000,
                                    showClose: true
                                })
                            }
                            if (errCallback) {
                                errCallback()
                            }
                        }
                    }
                }, err => {
                    // 请求异常
                    Message.error(err);
                    if (errCallback) {
                        errCallback()
                    }
                });
        }
    }
}
</script>

<style scoped>
/* 云盘外框 */
.drive-items {
    padding-left: 20px;
    padding-bottom: 0px;
    width: calc(100% - 60px);
}

/* 云盘 */
.drive-item {
    color: #2D3870;
    width: 100%;
    height: 72px;
    line-height: 44px;
    padding: 0 10px;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 10px;
    background-color: #FFF;
    position: relative;
}

.drive-item:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.el-icon-more {
    display: none;
}

.drive-item:hover .el-icon-more {
    display: inline-block;
}

/* 云盘选中 */
.drive-item.selected {
    background-color: #FFF !important;
}

/* 云盘图标 */
.drive-item-icon {
    width: 34px;
    height: 34px;
    display: inline-block;
    background-size: 34px;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: center;
}

/* 云盘选中 */
.drive-item-line {
    width: 4px;
    height: 52px;
    display: none;
    background: #5562B4;
    position: absolute;
    z-index: 1;
    left: -10px;
    top: 9px;
}

.drive-item.selected>.drive-item-line {
    display: block;
}

/* 云盘文字 */
.drive-item-text {
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    width: calc(100% - 50px);
}

/* 云盘名称 */
.drive-item-name {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: bold;
    height: 40px;
    line-height: 50px;
}

/* 云盘描述 */
.drive-item-desc {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 32px;
    line-height: 20px;
    font-size: 12px;
}

/* 云盘项-更多图标 */
.drive-item i {
    float: right;
    margin-top: 13px;
    margin-right: 3px;
    cursor: pointer;
}

/* 云盘信息弹窗 */
.lite_popup_box {
    width: 480px;
}

/* 云盘信息头 */
.drive_info .el-form-item__label {
    position: relative;
    top: 0px;
}

/* 云盘信息间距 */
.drive_info .el-form-item {
    margin-bottom: 0px;
}

.drive_info_text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.drive_more_icon {
    width: 22px;
    height: 22px;
    background-image: url('../../assets/images/lite/icon/more_dot.svg');
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    right: 10px;
    top: 25px;
    cursor: pointer;
    border-radius: 4px;
    display: none;
}

.drive-item.selected .drive_more_icon,
.drive-item:hover .drive_more_icon {
    display: block;
}

.drive_more_icon:hover {
    background-color: #00000015;
}

.drive_more_items {
    user-select: none;
    border: 1px solid #8a96e3;
    background: #fff;
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
}

.drive_more_item {
    background-position: 19px 9px;
    background-size: 16px;
    background-repeat: no-repeat;
    text-indent: 30px;
    color: rgba(0, 0, 0, 0.6);
    height: 34px;
    line-height: 34px;
    cursor: pointer;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
}

.drive_more_item:hover {
    background-color: #ebf3fe;
}

.drive_edit {
    background-image: url('../../assets/images/vectorImg/icon_edit.svg');
}

.drive_rename {
    background-image: url('../../assets/images/vectorImg/icon_rename.svg');
}

.drive_delete {
    background-image: url('../../assets/images/vectorImg/icon_Remove.svg');
}

.drive_properties {
    background-image: url('../../assets/images/vectorImg/icon_Options.svg');
}

.websit_info_items {
    overflow: auto;
    max-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/lite_drive.vue